export const carrierEntities = [
  {
    key: 'individual',
    value: 'individual',
    label: 'Individual/sole proprietor or single member LLC',
  },
  { key: 'ccorp', value: 'ccorp', label: 'C Corporation' },
  { key: 'scorp', value: 'scorp', label: 'S Corporation' },
  { key: 'partnership', value: 'partnership', label: 'Partnership' },
  { key: 'trust', value: 'trust', label: 'Trust/Estate' },
  { key: 'llc', value: 'llc', label: 'Limited Liability Company' },
]

export const EXTERNAL_ENTITY = { name: 'Search SAFER', value: 'EXTERNAL_ENTITY', id: 'EXTERNAL_ID' }
